import type { RouteObject } from "react-router-dom";
import AppError from "../app-error";
import AuditList, { auditListLoader } from "./List";

/**
 * Scoped route config for this area, same shape as `../customers/routes.tsx`. NOT wired into
 * `main.tsx` yet — see this feature's WIRING NEEDED note.
 */
export const auditRoutes: RouteObject[] = [
  { path: "audit", Component: AuditList, loader: auditListLoader, errorElement: <AppError /> },
];
